import * as React from 'react';

import Message from 'antd/lib/message';
import Input from 'antd/lib/input';

import * as Yup from 'yup';
import { Formik, FormikProps, FormikHelpers } from 'formik';

import { emailValidator, simpleStringValidator } from '@common/react/utils/validationHelpers';
import Button from '@common/react/components/Forms/Button';
import FormikField from '@common/react/components/Forms/FormikField/FormikField';
import { useApplicationContext } from '@common/react/components/Core/Application/Application';

import { User } from '@app/objects/User';

interface IFormValues {
	fullName: string;
	email: string;
	subject: string;
	message: string;
}

const validationSchema = Yup.object().shape({
	fullName: simpleStringValidator,
	email: emailValidator,
	message: simpleStringValidator,
});

const ContactSupport: React.FC = () => {
	const [isLoading, setIsLoading] = React.useState<boolean>(false);
	const [error, setError] = React.useState<string>('');
	const { request, getUser } = useApplicationContext();
	const user = getUser<User>();

	const onSubmit = (values: IFormValues, formikHelpers: FormikHelpers<IFormValues>) => {
		setIsLoading(true);
		setError('');

		request<IFormValues>('sendSupportEmail', values)
			.then(() => {
				setIsLoading(false);
				Message.success('Your email has been successfully sent.');
				formikHelpers.resetForm();
			})
			.catch((err) => {
				setIsLoading(false);

				if (typeof err === 'string') {
					setError(err);
				} else {
					setError('Something went wrong.');
				}
			});
	};

	return <>
		<Formik<IFormValues>
			initialValues={{
				fullName: user ? `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}` : '',
				email: user?.email || '',
				subject: '',
				message: '',
			}}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
		>
			{(formikProps: FormikProps<IFormValues>) => <>
				<div className="row">
					<FormikField
						title="Full Name*"
						fieldName="fullName"
						containerClassName="form-group col-sm-12"
					/>
				</div>
				<div className="row">
					<FormikField
						title="Email*"
						fieldName="email"
						containerClassName="form-group col-sm-12"
					/>
				</div>
				<div className="row">
					<FormikField
						title="Subject"
						fieldName="subject"
						containerClassName="form-group col-sm-12"
					/>
				</div>
				<div className="row">
					<FormikField
						title="Message*"
						fieldName="message"
						containerClassName="form-group col-sm-12"
						render={({ field }) =>
							<Input.TextArea
								className="form-control input-textarea"
								style={{ minHeight: '68px', resize: 'none' }}
								autoSize={{ minRows: 3, maxRows: 10 }}
								{...field}
							/>
						}
					/>
				</div>
				<div className="mb10 text-center">
					<Button
						type="button"
						className="btn btn-sm btn-primary"
						isLoading={isLoading}
						onClick={() => formikProps.handleSubmit()}
					>
						Send Message
					</Button>
				</div>
				{error && <div className="alert alert-danger">{error}</div>}
			</>}
		</Formik>
	</>;
};

export default ContactSupport;
